import { render, staticRenderFns } from "./Press_releases.vue?vue&type=template&id=1806dae9&"
import script from "./Press_releases.vue?vue&type=script&lang=js&"
export * from "./Press_releases.vue?vue&type=script&lang=js&"
import style0 from "./Press_releases.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports